var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

var SvgWarning = function SvgWarning(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#warning_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.488.277a1.992 1.992 0 0 1 2.762.756l4.902 8.792.002.004A2.812 2.812 0 0 1 11.688 14H3.315A2.812 2.812 0 0 1 .852 9.834v-.002l4.904-8.8C5.93.72 6.181.46 6.488.278ZM8.203 4.55a.7.7 0 0 0-1.4 0v2.8a.7.7 0 0 0 1.4 0v-2.8Zm-.7 4.656a1.05 1.05 0 1 1 0 2.101 1.05 1.05 0 0 1 0-2.1Z",
    fill: "var(--color-primary-negative)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "warning_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h14v14H0z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export default ForwardRef;